import { render, staticRenderFns } from "./ViolenceSurveyCalculator.vue?vue&type=template&id=3cb6af75&"
import script from "./ViolenceSurveyCalculator.vue?vue&type=script&lang=js&"
export * from "./ViolenceSurveyCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports